import script from "./patent.vue?vue&type=script&setup=true&lang=js"
export * from "./patent.vue?vue&type=script&setup=true&lang=js"

import "./patent.vue?vue&type=style&index=0&id=cfab537c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfab537c"]])

export default __exports__